import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import AlertModalV2, { useAlertModalV2Reducer } from "../../AlertV2";
import { useAuth } from "../../../Auth";
import { createPortal } from "react-dom";
import { okCallbackInspection } from "./util";
import "./index.css";

const StartInspection = ({ title, style, icon, type = "btn", vehicleId = 0, hideSubMenu = null }) => {
    const history = useHistory();
    const { api } = useAuth();
    const { state, dispatch: alertDispatch, closeModal } = useAlertModalV2Reducer();
    const { okText, buttonNumber, textArray, show } = state;

    const handleStartInspection = useCallback(async () => {
        if (typeof hideSubMenu === "function") {
            await hideSubMenu();
        }
        if (Number.parseInt(vehicleId) > 0) {
            history.push("/inspection/" + vehicleId);
        } else {
            history.push("/inspection");
        }
    }, [hideSubMenu, history, vehicleId]);

    const okCallback = useCallback(async () => {
        await okCallbackInspection({
            api,
            okText,
            alertDispatch,
            history,
            closeModal,
            vehicleId
        });
    }, [api, closeModal, alertDispatch, history, okText, vehicleId]);

    const cancelCallback = () => {
        closeModal();
        history.push("/fleet/overview");
    }

    return (
        <>
            <button
                type="button"
                className={type === "btn" ? "startInspectionBtn" : "startInspectionLink"}
                style={{ ...style }}
                onClick={handleStartInspection}
            >
                {icon}
                {title}
            </button>

            <PanelPortal>
                <AlertModalV2
                    show={show}
                    buttonNumber={buttonNumber}
                    textArray={textArray}
                    okCallback={okCallback}
                    cancelCallback={cancelCallback}
                    okText={okText}
                />
            </PanelPortal>
        </>
    );
};

const PanelPortal = ({ children }) => {
    if (typeof document === "undefined") return null;
    const target = document.getElementById("modal-root") || document.body;
    return createPortal(children, target);
};

export default StartInspection;
